import styled, { css } from 'styled-components'
import { CSVLink } from 'react-csv'

const commonStyle = css`
  border: 1px solid #b9b9b9;
  text-align: center;
  vertical-align: middle;
  height: 35px;
  min-width: 120px;
`

export const StyledWrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
`

export const StyledTableWrapper = styled.section`
  max-height: 300px;
  overflow: auto;
`

export const StyledTable = styled.table`
  max-width: 1000px;
  display: block;
  white-space: nowrap;
`
export const StyledThead = styled.thead``

export const StyledTbody = styled.tbody``

export const StyledTh = styled.th`
  ${commonStyle}
`

export const StyledTr = styled.tr``

export const StyledTd = styled.td`
  ${commonStyle}

  ${props =>
    props.isHighlight &&
    css`
      background-color: rgba(255, 121, 141, 0.24);
    `}
`

export const StyledLinkWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 230px;
  margin: 10px;
  height: 48px;
  border-radius: 16px;

  ${props =>
    css`
      background-color: ${props.theme.colors.primary};
    `}
`

export const StyledDownloadLink = styled(CSVLink)`
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: #ffffff;
  text-align: center;

  &:hover,
  &:focus {
    text-decoration: none;
    color: #ffffff;
  }
`
export const StyledButton = styled.div`
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: #ffffff;
  height: 48px;
  border-radius: 16px;
  width: 230px;
  margin: 10px;
  cursor: pointer;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover,
  &:focus {
    text-decoration: none;
    color: #ffffff;
  }
  ${props =>
    css`
      background-color: ${props.theme.colors.primary};
    `}
`
export const StyledButtonGroupWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 56px;
  width: 500px;
`
export const StyledButtonContent = styled.div`
  margin: 20px;
  flex: 1;
`
